/* ───────────── CONFIG ───────────── */
const API_KEY = '8d636a0ccef8402fa496e8b9d75f8c1f'; 

const GEO_ENDPOINT = `https://api.ipgeolocation.io/ipgeo?apiKey=${API_KEY}&fields=state_code,country_code2`;

const STATE_COOKIE = 'selectedState';
const STATE_DAYS   = 365;

const TIP_COOKIE   = 'stateTooltipDismissed';
const TIP_DAYS     = 30;

const US_STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA','KS',
  'KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY',
  'NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV',
  'WI','WY'
];

/* ─────────── SHARED HELPERS ────────── */
window.StateSelect = window.StateSelect || {};

if (!StateSelect.setCookie) {
  StateSelect.setCookie = (name, value, days = 365) => {
    let exp = '';
    if (days) {
      const d = new Date();
      d.setTime(d.getTime() + days * 864e5);
      exp = '; expires=' + d.toUTCString();
    }
    document.cookie = `${name}=${encodeURIComponent(value)}${exp}; path=/; SameSite=Lax`;
  };

  StateSelect.getCookie = (name) => {
    const n = `${name}=`;
    return (
      document.cookie
        .split(';')
        .map((c) => c.trim())
        .find((c) => c.startsWith(n))
        ?.substring(n.length) || ''
    );
  };
}

/* ========= Geo-IP Detect if no Cookie Set ========= */
(async () => {
  if (StateSelect.getCookie(STATE_COOKIE)) return;

  try {
    const res = await fetch(GEO_ENDPOINT, { cache: 'no-store' });
    
    // If the API Key is wrong or domain is rejected, this throws an error
    if (!res.ok) throw new Error(`Geo-IP request failed: ${res.status}`);

    const data = await res.json();
    
    // Parse ipgeolocation.io JSON
    const country = data.country_code2; 
    let code = data.state_code;         

    // Safety cleanup
    if (code) code = code.replace(/^US-/, '');

    // Check validity
    if (country === 'US' && US_STATES.includes(code)) {
      
      StateSelect.setCookie(STATE_COOKIE, code, STATE_DAYS);
      
      // Wait for DOM to ensure UI exists
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => updateUI(code));
      } else {
        updateUI(code);
      }

    } else {
      // Fallback
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => StateSelect.maybeShowTooltip?.('', true));
      } else {
        StateSelect.maybeShowTooltip?.('', true);
      }
    }

  } catch (err) {
    console.warn('Geo-IP unavailable:', err);
    StateSelect.maybeShowTooltip?.('', true);
  }
})();

// Helper to safely run UI updates
function updateUI(code) {
  if (StateSelect.updateHeaderText) {
    StateSelect.updateHeaderText(code);
  }
  StateSelect.maybeShowTooltip?.(code);
  StateSelect.applyProductRestrictions?.(code);
}

/* ───────────── Tooltip Display ───────────── */
function injectTooltip(stateCode = '', isFallback = false) {
  if (StateSelect.getCookie(TIP_COOKIE)) return;

  const trigger = document.querySelector('[aria-controls="StateDrawer"]');
  if (!trigger) return;

  const labelState = stateCode || 'your state?';

  const header = isFallback ? 'Shipping Location' : `Ship to ${labelState}`;
  const text = isFallback
    ? 'We ship to all 50 US states. Please select your state so we can show you products available there.'
    : 'Sending your order somewhere else? Select the correct state to view products available there.';

  const tip = document.createElement('div');
  tip.className = 'state-tooltip';
  tip.innerHTML = `
    <p class="tooltip-header">${header}</p>
      <button type="button" class="tip-close" aria-label="Close tooltip">
        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 24 24">
          <path d="M18.75 5.13496L5.25 18.8544" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M18.75 18.8544L5.25 5.13496" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    <p class="tooltip-text">${text}</p>
  `;

  trigger.appendChild(tip);

  tip.querySelector('.tip-close').addEventListener('click', (e) => {
    e.stopPropagation();
    tip.remove();
    StateSelect.setCookie(TIP_COOKIE, '1', TIP_DAYS);
  });
}

/* ───────────── Product-card Hiding (Grid & Menu) ───────────── */
function restrictCards(state) {
  document
    .querySelectorAll('.product-card[data-excluded-states]')
    .forEach((card) => {
      const restricted = card.dataset.excludedStates
        .split(',')
        .map((s) => s.trim());
      
      // MODIFIED: Look for '.promotion-item' (menu) OR '.f-column' (grid)
      const container = card.closest('.promotion-item') || card.closest('.f-column');

      if (!container) return; // If we can't find a container, do nothing

      if (restricted.includes(state)) {
        container.style.display = 'none';
      } else {
        container.style.display = '';
      }
    });
}

/* ───────────── Menu Link Hiding (Desktop & Mobile) ───────────── */
function restrictMenuLinks(state) {
  // Select ANY element with the attribute (<li> for desktop, <a> for mobile)
  document
    .querySelectorAll('[data-shipping-restrictions]')
    .forEach((item) => {
      const rawData = item.dataset.shippingRestrictions;
      
      // Split by comma and clean up whitespace
      const restricted = rawData.split(',').map((s) => s.trim());

      if (restricted.includes(state)) {
        // Hide the element itself
        item.style.display = 'none';

        // IMPORTANT: If the restricted item is a Link (<a>), 
        // we must also hide its parent List Item (<li>).
        // This prevents empty gaps or bullets in the mobile menu.
        if (item.tagName === 'A') {
          const parentLi = item.closest('li');
          if (parentLi) parentLi.style.display = 'none';
        }

      } else {
        // Reset visibility
        item.style.display = ''; 
        
        if (item.tagName === 'A') {
          const parentLi = item.closest('li');
          if (parentLi) parentLi.style.display = '';
        }
      }
    });
}

// Expose functions to global namespace
StateSelect.maybeShowTooltip         = injectTooltip;
StateSelect.applyProductRestrictions = restrictCards;
StateSelect.applyMenuRestrictions    = restrictMenuLinks; // ADDED: Expose to window

/* ───────────── Run on every page load ───────────── */
document.addEventListener('DOMContentLoaded', () => {
  const state = StateSelect.getCookie(STATE_COOKIE);
  if (state) {
    restrictCards(state);
    restrictMenuLinks(state); // ADDED: Run menu restrictions on load
    injectTooltip(state);
    if (StateSelect.updateHeaderText) StateSelect.updateHeaderText(state);
  }
});